const getReferrerUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const returnUrl = urlParams.get("return_url");

  if (returnUrl) {
    return returnUrl;
  }

  if (document.referrer && document.referrer !== window.location.href) {
    return document.referrer;
  }

  return "/";
};

const hideLoader = () => {
  const loader = document.getElementById("wholesale-inquiry-loader");
  if (loader) {
    loader.style.display = "none";
  }
};

const initWholesaleInquiryLoader = () => {
  window.addEventListener("hs-form-event:on-ready", hideLoader);
};

const initWholesaleInquiryRedirect = () => {
  window.addEventListener("hs-form-event:on-submission:success", () => {
    const returnUrl = getReferrerUrl();
    window.location.replace(returnUrl);
  });
};

const initWholesaleInquiry = () => {
  const formContainer = document.querySelector(".wholesale-inquiry-container");
  if (!formContainer) {
    return;
  }

  initWholesaleInquiryLoader();
  initWholesaleInquiryRedirect();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initWholesaleInquiry);
} else {
  initWholesaleInquiry();
}

export default initWholesaleInquiry;
